export default __webpack_public_path__ + "static/media/feature7_3.da9a07c7.png";